module.exports = __webpack_public_path__ + "static/images/editTemplateIcon.32c18a73.svg";